module.exports = __webpack_public_path__ + "static/img/ic_itembox_normal.c053de47.svg";